import { render, staticRenderFns } from "./GroupAdmin.vue?vue&type=template&id=6872586e&scoped=true&"
import script from "./groupAdmin.ts?vue&type=script&lang=ts&"
export * from "./groupAdmin.ts?vue&type=script&lang=ts&"
import style0 from "./GroupAdmin.vue?vue&type=style&index=0&id=6872586e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872586e",
  null
  
)

export default component.exports